export default "__VITE_ASSET__Dj1GJRQO__"